export default __webpack_public_path__ + "static/media/expl-gradcam_03_EN.019ccebc.png";